import React, { Component } from "react";
import { ButtonToolbar, Table, Grid } from 'react-bootstrap';

import { LoadingSpinner } from '../../LoadingSpinner';
import { SortIndicator } from '../../SortIndicator';
import { PaginationBuilder } from '../../PaginationBuilder';
import { SearchHelper } from '../../helpers/SearchHelper';
import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { TableButton } from '../../TableButton';

import ColumnResize from "react-table-column-resizer";

export class StopsActive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            render: {
                sort: {
                    property: "code",
                    type: "ascending"
                }
            }
        }
    }

    // -----------------------

    getStopLines(stops) {
        const stop = stops.find(s => s.lines === undefined);

        if (undefined !== stop) {
            this.props.getStopLines(stop);
            stop.lines = [];
        }
    }

    getStopMunicipality(stops) {
        const stop = stops.find(s => s.lines === undefined);

        if (undefined !== stop) {
            this.props.getStopMunicipality(stop);
            stop.municipality = [];
        }
    }

    // -----------------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    // -----------------------

    filterByInfo(value) {
        return value.map(v => v).join();
    }

    sortStops(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if(undefined === aValue) {
            aValue = "";
        }

        if(undefined === bValue) {
            bValue = "";
        }

        if (aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;
        if ("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // -----------------------

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if (property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    renderIsActiveLabel(isActive) {
        return isActive ? "Sim" : "Não";
    }

    renderStopInfo(stopInfo, index) {
        return stopInfo !== undefined ? stopInfo.map((info, i) => <li key={`stop-${index}-info-${i}`}>{info}</li>) : null;
    }

    renderStopLines(stopLines, index) {
        return stopLines !== undefined ? stopLines.map((line, i) => <li key={`stop-${index}-line-${i}`}>{line}</li>) : null;
    }

    renderMapPoint(mapPoint) {
        if(undefined === mapPoint) {
            return null;
        }

        return ComparisonHelper.renderProperty(mapPoint.name);
    }

    renderInterfaces(stop) {
        const stopInterfaces = stop.interfaces || [];
        let mapPointInterfaces = [];
        if(undefined !== stop.mapPoint && undefined !== stop.mapPoint.interfaces) {
            mapPointInterfaces = (stop.mapPoint.interfaces || []).filter(mapInt =>
                !stopInterfaces.some(stopInt => stopInt.id === mapInt.id)
            );
        }

        return (
            <div>
                {stopInterfaces.map((interfaceItem, idx) => (
                    <div key={`stop-interface-${idx}`} className="interface stop-only">
                        {interfaceItem.namePt}
                    </div>
                ))}

                {mapPointInterfaces.map((interfaceItem, idx) => (
                    <div key={`map-point-interface-${idx}`} className="interface map-point">
                        {interfaceItem.namePt}
                    </div>
                ))}
            </div>
        );
    }

    render() {
        const { render } = this.state;
        const { stops, isLoading, currentPage, elementsPerPage, isComparing, filter } = this.props;

        let stopsFiltered;
        if (isComparing) {
            const { draftStops } = this.props;

            stopsFiltered = SearchHelper.search({
                filter: filter,
                data: ComparisonHelper.compare(
                    stops,
                    draftStops,
                    {
                        match: [{ left: "code", right: "code" }],
                        fields: [{ left: "extCode", right: "externalCode" }, { left: "name", right: "name" }, {left: "info", right: "info"}]
                    }),
                fields: ["code", "code.left", "code.right", "name", "name.left", "name.right", "shortName", "extCode", "extCode.left", "extCode.right", "isActive", "isActive.left", "isActive.right", "mapPoint.name", "info"],
                valueParser: {
                    "isActive": {
                        "true": "sim",
                        "false": "não"
                    }
                },
                callbackComparison: [{ "info": (a) => this.filterByInfo(a) }]
            });
        }
        else {
            stopsFiltered = SearchHelper.search({
                filter: filter,
                data: stops,
                fields: ["code", "name", "shortName", "extCode", "isActive", "mapPoint.name", "info"],
                valueParser: {
                    "isActive": {
                        "true": "sim",
                        "false": "não"
                    }
                },
                callbackComparison: [{ "info": (a) => this.filterByInfo(a) }]
            });
        }

        const totalPages = PaginationHelper.getTotalPages(stopsFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const stopsToRender = stopsFiltered.sort((a, b) => this.sortStops(render.sort, a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        this.getStopMunicipality(stopsToRender);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th className="sortable" onClick={() => this.onChangeSort("code")}>Código {this.renderSortIndicator("code", render.sort)}</th>
                                <ColumnResize className="columnResizer" />
                                <th className="sortable" onClick={() => this.onChangeSort("extCode")}>Código Externo {this.renderSortIndicator("extCode", render.sort)}</th>
                                <ColumnResize className="columnResizer" />
                                <th className="sortable" onClick={() => this.onChangeSort("name")}>Nome {this.renderSortIndicator("name", render.sort)}</th>
                                <ColumnResize className="columnResizer" />
                                <th>Ativa</th>
                                <ColumnResize className="columnResizer" />
                                <th className="sortable" onClick={() => this.onChangeSort("latitude")}>Latitude {this.renderSortIndicator("latitude", render.sort)}</th>
                                <ColumnResize className="columnResizer" />
                                <th className="sortable" onClick={() => this.onChangeSort("longitude")}>Longitude {this.renderSortIndicator("longitude", render.sort)}</th>
                                <ColumnResize className="columnResizer" />
                                <th>Ponto Notável</th>
                                <ColumnResize className="columnResizer" />
                                <th>Interfaces Associadas</th>
                                <ColumnResize className="columnResizer" />
                                <th>Mun.</th>
                                <ColumnResize className="columnResizer" />
                                <th>Info. Adicional</th>
                                <ColumnResize className="columnResizer" />
                                <th>Linhas</th>
                                <ColumnResize className="columnResizer" />
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "overlay" : ""}>
                            {
                                stopsToRender.map((stop, idx) =>
                                    <tr key={`stop-${idx}`} className={ComparisonHelper.getRowClass(stop.code)}>
                                        <td>{ComparisonHelper.renderProperty(stop.code)}</td>
                                        <td className="column_resizer_body" />
                                        <td>{ComparisonHelper.renderProperty(stop.extCode)}</td>
                                        <td className="column_resizer_body" />
                                        <td>{ComparisonHelper.renderProperty(stop.name)}</td>
                                        <td className="column_resizer_body" />
                                        <td>{ComparisonHelper.renderProperty(stop.isActive, (a) => this.renderIsActiveLabel(a))}</td>
                                        <td className="column_resizer_body" />
                                        <td>{ComparisonHelper.renderProperty(stop.latitude)}</td>
                                        <td className="column_resizer_body" />
                                        <td>{ComparisonHelper.renderProperty(stop.longitude)}</td>
                                        <td className="column_resizer_body" />
                                        <td>{this.renderMapPoint(stop.mapPoint)}</td> 
                                        <td className="column_resizer_body" />
                                        <td>{this.renderInterfaces(stop)}</td>
                                        <td className="column_resizer_body" />
                                        <td>{ComparisonHelper.renderProperty(stop.municipality)}</td>
                                        <td className="column_resizer_body" />
                                        <td>{ComparisonHelper.renderProperty(stop.info, (a) => this.renderStopInfo(a, idx))}</td>
                                        <td className="column_resizer_body" />
                                        <td>
                                            {typeof stop.lines === "undefined"
                                                ? <LoadingSpinner className="stopsLoading" />
                                                : ComparisonHelper.renderProperty(stop.lines, (a) => this.renderStopLines(a, idx))
                                            }
                                        </td>
                                        <td className="column_resizer_body" />
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(stop)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(stop)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <PaginationBuilder
                        currentPage={activePage}
                        elementsPerPage={elementsPerPage}
                        dataLength={stopsFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)} />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}
